import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const campaignManagementAdminAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CampaignManagementView, Permission.CampaignManagementModify],
    restrictedBannersAllowed: true,
  },
  {
    permissions: [
      Permission.CampaignManagementPageBuilderView,
      Permission.CampaignManagementPageBuilderModify,
    ],
    restrictedBannersAllowed: true,
  },
]

// Permissions for managing Theme Pages
// TODO: Add granular permissions for managing Theme Pages later
export const campaignManagementThemePageAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementView, Permission.CampaignManagementModify],
  restrictedBannersAllowed: true,
}

export const campaignManagementAdminCalendarPageAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.adminCalendarPage],
}

export const campaignManagementAdminCreativesPageAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.adminCreativesPage],
  permissions: [
    Permission.CampaignManagementPageBuilderView,
    Permission.CollectionsView,
    Permission.RecipesView,
    Permission.StoreConfigsView,
    Permission.CatalogProductsView,
  ],
  restrictedBannersAllowed: true,
}

export const campaignManagementAdminRedemptionUrls: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.campaignManagementRedemptionUrls],
  permissions: [Permission.CampaignManagementPageBuilderView, Permission.CampaignManagementView],
}

export const campaignManagementAdminMultiRetailerPages: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.campaignManagementMultiRetailerPages],
}

export const campaignManagementAdminMultiRetailerPagesViewControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementPageBuilderView],
  restrictedBannersAllowed: true,
}

export const campaignManagementAdminMezcalPagesControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementPageBuilderModify],
  featureToggles: [FeatureToggle.adminMezcalPages],
}

export const campaignManagementAdminMultiRetailerPagesModifyControl: DomainAccessControlConfig = {
  permissions: [Permission.CampaignManagementPageBuilderModify],
  restrictedBannersAllowed: true,
}

// Froth template admin RPCs are gated on the mesh side by
// `frothTemplateAdminOnlyCheck`, which requires `admin_panel.legacy_permission`
// with full-partner access. Mirror that here so the page and its actions are
// only reachable by Instacart admins during the POC.
export const campaignManagementAdminTemplates: DomainAccessControlConfig = {
  permissions: [Permission.AdminPanel],
}
